import React from 'react';
import Services from '../components/Services';

const ServicesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <h1 className="page-title">Our Services &amp; Facilities</h1>
          <p className="page-subtitle">
            Explore the different ways you can use the TDS Event Center, from weddings and reunions to sports and fitness.
          </p>
        </div>
        <Services />
      </div>
    </div>
  );
};

export default ServicesPage;


